module.exports = __webpack_public_path__ + "static/media/collaboration.b024efae.svg";